import React, { Fragment, useEffect, useState } from 'react';
import './styles.scss';
import ExportInventoryModal from 'components/cs/modals/export-inventory-modal';
import { ReactComponent as FolderDownloadIcon } from 'assets/icons/folder-download.svg';
import { BrandType } from 'models/brand.model';
import { Dropdown } from '@cokitchen/cokitchen-components';

import { apiService } from 'utils/api';
import useDashboardContext from 'contexts/dashboard.context';
import InventoryBaseMeal from 'components/kitchen/inventory-base-meal';
import FilterList from 'components/kitchen/filter-list';

type FilterType = { active: boolean; key: string; title: string; number: number }[];
const MealProductionTracker = () => {
  const [filters, setFilters] = useState<FilterType | []>([]);
  const [meals, setMeals] = useState([]);
  const [brands, setBrands] = useState<BrandType[] | null>(null);
  const [loading, setLoading] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [filteredBrands, setFilteredBrands] = useState<BrandType[]>([]);
  const { activeCokitchen } = useDashboardContext();
  const [brandOptions, setBrandOptions] = useState<{ value: string; text: string }[]>([]);
  const [activeBrand, setActiveBrand] = useState<BrandType | null>(null);

  const fetchData = async () => {
    if (!activeCokitchen?.id) return;
    try {
      setLoading(true);
      const res = await apiService.get('base/brands', {
        baseUrl: process.env.REACT_APP_BRAND_MGT_API_URL
      });
      setBrands(res?.data?.data);
      setActiveBrand(res?.data?.data[0]);
      setFilteredBrands(res?.data?.data);
    } catch {
      setBrands(null);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!brands) return;
    const optionsArr: { value: string; text: string }[] = [{ text: 'All', value: 'all' }];
    brands?.forEach((brand) => {
      optionsArr.push({
        value: brand.id,
        text: brand.name
      });
    });
    setBrandOptions(optionsArr);
  }, [brands]);
  useEffect(() => {
    fetchData();
  }, []);

  const fetchBaseMeals = async () => {
    setLoading(true);
    if (!activeBrand?.id) return;
    try {
      const res = await apiService.get(`base-meal-quantity`, {
        params: { cokitchen_id: activeCokitchen?.id, brand_id: activeBrand?.id },
        baseUrl: process.env.REACT_APP_BRAND_MGT_API_URL
      });
      setFilters(
        brands?.map((b) => {
          return {
            active: activeBrand?.id ? b.id === activeBrand?.id : brands[0]?.id === b.id,
            key: b.id,
            title: b.name,
            number: 0
          };
        }) ?? []
      );
      setMeals(res?.data?.data);
    } catch {
      console.log('error');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchBaseMeals();
  }, [activeBrand]);

  return (
    <div>
      {!loading && filteredBrands.length === 0 ? (
        <p>Select a brand</p>
      ) : (
        <Fragment>
          {brands && brands?.length > 0 && (
            <div className='flex gap-4   overflow-x-scroll'>
              <FilterList
                onFilterClick={(e) =>
                  setActiveBrand(brands.find((b) => b.name === e.title) ?? null)
                }
                filters={filters}
              />
            </div>
          )}

          {loading ? (
            <p className='text-sm font-medium'> Loading</p>
          ) : !activeBrand?.name ? (
            <p className='font-medium text-sm mt-6 '> Select a brand to load base meals from</p>
          ) : meals.length === 0 ? (
            <p className='mt-6 text-sm font-medium'>No base meals found in {activeBrand?.name}</p>
          ) : (
            <Fragment>
              <div className='grow flex gap-4 object-contain whitespace-nowrap overflow-x-auto pr-24 mt-8'>
                {meals.length !== 0 && (
                  <InventoryBaseMeal
                    key={activeBrand?.id}
                    meals={meals}
                    brandId={activeBrand?.id ?? ''}
                    brandName={activeBrand?.name}
                    cokitchenId={activeCokitchen?.id}
                  />
                )}
              </div>
              <div className='fixed bottom-[11rem] right-[3rem] z-10'>
                <Dropdown
                  tooltip
                  interactive
                  arrow
                  content={
                    <div
                      className='cursor-pointer p-[14px] bg-red-5 rounded-full shadow-lg shadow-[#5b5a5a]'
                      onClick={() => setShowExportModal(true)}>
                      <FolderDownloadIcon className='text-white w-9 h-9' />
                    </div>
                  }>
                  <div className='bg-white p-4 shadow-lg rounded-lg min-w-[300px]'>
                    Download inventory to view items you have in stock. lorem ipssum dulom, dummy
                    text to fill space later.
                  </div>
                </Dropdown>
              </div>
              {showExportModal && (
                <ExportInventoryModal
                  show
                  onClose={() => setShowExportModal(false)}
                  options={brandOptions}
                />
              )}
            </Fragment>
          )}
        </Fragment>
      )}
    </div>
  );
};

export default MealProductionTracker;
